import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e14vlockdx: FaireBrandEntity = {
  token: "b_e14vlockdx",
  type: "brand",
  name: "NULASTIN",
  avatarUrl:
    "https://cdn.faire.com/fastly/aab3b95be7ba1ba4470c81825df9436de412e6b364bb897c057aa0aba5d4c170.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f030cb290691677c51124bb0c8668f94d8eadf9c8c7e3ccd4d9d8b7df4ae2ae4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aab3b95be7ba1ba4470c81825df9436de412e6b364bb897c057aa0aba5d4c170.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f030cb290691677c51124bb0c8668f94d8eadf9c8c7e3ccd4d9d8b7df4ae2ae4.jpeg",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "At NULASTIN®, we believe healthy hair starts at the root. Our science-backed, elastin-powered formulas are designed to strengthen follicles and help promote fuller, stronger and more resilient hair.\n\nWe combine clinical research with innovative technology to create products that deliver real results, giving you the confidence to look and feel your best. Consistent care, powered by protein and smart science, is all it takes to transform your hair health.\n\nFrom scalp to strands, NULASTIN® is your partner in building a routine that works—backed by science, designed for real life and proven to deliver noticeable results.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:27.302Z",
    importedBy: "entity-db-cli",
  },
};
